export default function ThemeCard({ theme, selected, onClick }) {
    return (
        <button
            type="button"
            className={`wg-theme-card ${selected ? "selected" : ""}`}
            onClick={onClick}
        >
            <div className={`wg-theme-preview wg-theme-preview--${theme.key || "default"}`}>
                <div className="wg-theme-preview-bar" />
                <div className="wg-theme-preview-body">
                    <div className="wg-theme-preview-sidebar">
                        <span />
                        <span />
                        <span />
                    </div>

                    <div className="wg-theme-preview-content">
                        <div className="wg-theme-preview-hero" />
                        <div className="wg-theme-preview-grid">
                            <span />
                            <span />
                            <span />
                        </div>
                    </div>
                </div>
            </div>

            <div className="wg-theme-card-content">
                <div className="wg-theme-card-top">
                    <h3 className="wg-theme-name">{theme.name}</h3>
                    {selected && <span className="wg-theme-selected-badge">Selected</span>}
                </div>

                <p className="wg-theme-desc">{theme.description}</p>
                <div className="wg-theme-meta">{theme.key}</div>
            </div>
        </button>
    );
}